// keycloak-init.factory.ts
import { DynamicKeycloakService } from '../dynamic-keycloak.service';
import { getKeycloakContext, persistKeycloakContextFromUrlIfPresent } from '../auth/auth.utils';

export function initializeKeycloak ( dynamicKeycloakService: DynamicKeycloakService ) {
  return async () => {
    // If redirect URL contains Keycloak context params (e.g. after magic link), persist first
    persistKeycloakContextFromUrlIfPresent();

    const keycloakContext = getKeycloakContext()

    if( keycloakContext && keycloakContext?.authProvider === 'keycloak' ) {
      return await dynamicKeycloakService.ensureInitialized(
        keycloakContext.keycloak,
        {
          onLoad: 'check-sso',
          pkceMethod: 'S256',
          silentCheckSsoRedirectUri:
            window.location.origin + '/assets/keycloak/silent-check-sso.html',
        }
      );
    }
  };
}
